// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.BottomTimer[data-v-4b964117] {\n  height: 10px;\n  border-radius: 5px;\n  transform: scaleX(0);\n  background-color: #009fe3;\n  transition: 0.25s all;\n  will-change: transform;\n  transform-origin: left;\n  display: none;\n}\n.bg-alice[data-v-4b964117] {\n  background-color: #cde3ec;\n}\n", ""]);
// Exports
module.exports = exports;
